export const validateReservationForm = (data) => {
  const errors = {};
  if (!data.timeSlot) {
    errors.timeSlot = "Time slot is required.";
  }
  if (data.pax < 1) {
    errors.pax = "Pax is required.";
  }
  return errors;
};

export const validateReservationSettingsForm = (data) => {
  const errors = {};
  if (!data.timeSlot) {
    errors.timeSlot = "Time slot is required.";
  }
  if (!data.newSlotStatus) {
    errors.newSlotStatus = "New slot status is required.";
  }
  return errors;
};
